import Icon from '../components/Icon.vue'

Icon.register({
  'volume-off': {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M215 71c15-15 41-4.5 41 17v336c0 21.5-26 32-41 17l-88.9-89h-102.1c-13.2 0-24-10.8-24-24v-144c0-13.2 10.8-24 24-24h102z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/volume-off.js
// module id = 2095
// module chunks = 0